import snakecaseKeys from 'snakecase-keys'
import { format as dateFormat, parseISO, parse } from 'date-fns'

export const truncate = (str: string, n: number): string => {
  if (!str || !str.length) {
    return str
  }
  return str.length > n ? str.substr(0, n) + '...' : str
}

export function toSnakecaseKeys(obj: object, options?: { deep?: boolean }) {
  return snakecaseKeys(
    { ...obj },
    {
      deep: options?.deep ?? false,
    }
  )
}

const USDollar = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
})

export function formatCurrency(amount: number | string) {
  return USDollar.format(Number(amount))
}

export function formatNumber(value: number, fractionDigits: number = 0) {
  return new Intl.NumberFormat('en-US', {
    style: 'decimal',
    maximumFractionDigits: fractionDigits,
  }).format(value)
}

export function formatPercentage(value: number, fractionDigits: number = 0) {
  return new Intl.NumberFormat('en-US', {
    style: 'percent',
    maximumFractionDigits: fractionDigits,
  }).format(value)
}

export function formatDate(date: string, format: string = 'MMM d, yyyy') {
  return dateFormat(parseISO(date), format)
}

export function toTitleCase(text: string) {
  return typeof text === 'string'
    ? text
        .toLowerCase()
        .split(' ')
        .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
        .join(' ')
    : ''
}

export const toFirstName = (text: string) =>
  typeof text === 'string'
    ? text
        .toLowerCase()
        .split(' ')
        .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
        .join(' ')
        .split(' ')[0]
    : ''
